import { BpmnModelJsonHelper, JsonConvertableImpl } from "@edp-aif/common-api";

export class DocuTypeHelperEntity extends JsonConvertableImpl {
    id: string;
    moduleName: string;
    bizKindName: string;
    bizTypeName: string;
    code: string;
    name: string;

    constructor() {
        super();
    }

    protected ResetBeforeLoadFrom(): void {
        super.ResetBeforeLoadFrom();

        this.id = null;
        this.moduleName = null;
        this.bizKindName = null;
        this.bizTypeName = null;
        this.code = null;
        this.name = null;
    }

    public ConvertToJsonObject(): {} {
        let obj = super.ConvertToJsonObject();

        BpmnModelJsonHelper.SetAttributeValue(obj, "id", this.id);
        BpmnModelJsonHelper.SetAttributeValue(obj, "moduleName", this.moduleName);
        BpmnModelJsonHelper.SetAttributeValue(obj, "bizKindName", this.bizKindName);
        BpmnModelJsonHelper.SetAttributeValue(obj, "bizTypeName", this.bizTypeName);
        BpmnModelJsonHelper.SetAttributeValue(obj, "code", this.code);
        BpmnModelJsonHelper.SetAttributeValue(obj, "name", this.name);

        return obj;
    }

    public LoadFromJsonObject(obj: {}): void {
        super.LoadFromJsonObject(obj);

        this.id = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "id");
        this.moduleName = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "moduleName");
        this.bizKindName = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "bizKindName");
        this.bizTypeName = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "bizTypeName");
        this.code = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "code");
        this.name = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "name");
    }
}